import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Switch, Select, Button, Space, message } from 'antd';

const { Title, Paragraph } = Typography;
const { Option } = Select;

const TwoFactorAuth = () => {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      enforce_2fa_for_admins: true,
      enforce_2fa_for_agencies: false,
      default_method: 'totp',
      backup_codes_enabled: true,
    });
  }, [form]);

  const onSubmit = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      // PUT /api/security/2fa
      await new Promise(r => setTimeout(r, 350));
      message.success('Two-Factor Authentication settings saved');
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Admin' }, { title: 'Security' }, { title: 'Two-Factor Authentication' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Two-Factor Authentication</Title>
        <Space>
          <Button type="primary" onClick={onSubmit} loading={saving}>Save Settings</Button>
        </Space>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Configure 2FA policies and defaults.</Paragraph>
        <Form form={form} layout="vertical">
          <Form.Item label="Enforce 2FA for Super Admins & Staff" name="enforce_2fa_for_admins" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Enforce 2FA for Agency Users" name="enforce_2fa_for_agencies" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Default 2FA Method" name="default_method" rules={[{ required: true }]}> 
            <Select>
              <Option value="totp">Authenticator App (TOTP)</Option>
              <Option value="sms">SMS</Option>
              <Option value="email">Email</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Enable Backup Codes" name="backup_codes_enabled" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default TwoFactorAuth;
